import React from 'react';
import { FadeIn } from './FadeIn';
export function CTA() {
  return <section className="py-24 md:py-32 bg-durazno relative overflow-hidden" data-id="element-47">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-48">
        <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-rosa/40 blur-3xl" data-id="element-49" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-crema/40 blur-3xl" data-id="element-50" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-51">
        <FadeIn data-id="element-52">
          <h2 className="font-serif text-4xl md:text-6xl text-texto mb-8 leading-tight" data-id="element-53">
            Empezar a entender tu cuerpo puede cambiar la forma en que te mirás
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-54">
          <p className="font-sans text-xl text-texto/80 mb-12 max-w-2xl mx-auto" data-id="element-55">
            Cada ebook es una invitación a mirarte con más comprensión, más
            información y más amor. Tu cuerpo merece ser entendido.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-56">
          <a href="#ebooks" className="w-full sm:w-auto px-8 py-4 rounded-full bg-texto text-crema font-medium hover:bg-texto/90 transition-colors shadow-soft" data-id="element-57">
            Ver tienda
          </a>
          <a href="#temas" className="w-full sm:w-auto px-8 py-4 rounded-full bg-blanco text-texto font-medium hover:bg-crema transition-colors shadow-soft" data-id="element-58">
            Explorar ebooks
          </a>
          <a href="#contacto" className="w-full sm:w-auto px-8 py-4 rounded-full border border-texto/20 text-texto font-medium hover:bg-texto/5 transition-colors" data-id="element-59">
            Contacto
          </a>
        </FadeIn>
      </div>
    </section>;
}